import { useContext } from "react";
import { ABOVE_KEYBOARD_BOTTOM_GAP_PX } from "@-/dev.improve.haniverse.components.above-keyboard";
import { useToolbarGridMetrics } from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";
import { PrimaryNavigationStripFadeInsetContext } from "@-/dev.improve.haniverse.lib.primary-navigation-strip";
import { floatingSearchBubbleBottomGap } from "#floating-tab-bar-layout";

/**
 * Where the top of `FloatingRightSearchBubble`'s expanded field sits: `aboveSceneBottom` above the
 * bottom edge of its scene while the keyboard is down, and `aboveKeyboard` above the keyboard while
 * it is up. For content that must stop a fixed distance short of the field (Search's no-results
 * surface).
 */
export function useFloatingSearchBubbleTopInsets(): {
  aboveKeyboard: number;
  aboveSceneBottom: number;
} {
  const bottomTabFadeInset = useContext(PrimaryNavigationStripFadeInsetContext);
  // The expanded field is `diameter` tall and sits at the bottom of the bubble's row.
  const { diameter } = useToolbarGridMetrics();
  return {
    aboveKeyboard: ABOVE_KEYBOARD_BOTTOM_GAP_PX + diameter,
    aboveSceneBottom: floatingSearchBubbleBottomGap + bottomTabFadeInset + diameter,
  };
}
